
export const RotateTrial = (() => {

	function init () {

		if ($("#rotate_trial")) {
			initRotateTrial();
		}
	}

	function initRotateTrial() {

		$("#rotate_trial_form").submit(() => {
			$("#rotate_trial input[type=submit]").prop("disabled", true);

			const ps = $("#rotate_trial input[type=radio][name=ps]:checked").val();

			if (!ps) {
				alert("Please select either basic or pro");
				return false;
			}

			const payload = {
				ps: ps
			};

			$.ajax({
				url: "/rotate/trial_init",
				type: "post",
				dataType: "json",
				data: payload,
			})
				.then(function () {
					$("#rotate_trial_activate").hide();
					$("#rotate_trial_activated").show();
				})
				.catch(function (rsp) {

					$("#rotate_trial input[type=submit]").prop("disabled", false);

					let errorCode = '';
					if (rsp.responseJSON && rsp.responseJSON.code) {
						errorCode = rsp.responseJSON.code;
					}

					switch (errorCode) {
						case 'ineligible-for-trial':
							alert("We're sorry, your account is not eligible for trial. This means you've already used your trial, or have had a subscription which included this product.");
							break;

						default:
							alert("There was an unknown error. Please contact support.");
					}
				});

			return false;

		});
	}

	return {
		init: init,
	};
})();

